import { createStyles, makeStyles } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import Layout from '../components/Layout/Layout'
import LoginForm from '../components/UserForm/LoginForm'
import RegisterForm from '../components/UserForm/RegisterFrom'
import { getUser, loginUser, registerUser } from '../redux/actions/user'
import { connect } from 'react-redux'
import { useRouter } from 'next/router'
import ForgotPasswordForm from '../components/UserForm/ForgotPasswordForm'
import { getTranslations } from '../i18n'
import { useTranslation } from 'react-i18next'
import { setFullLocale } from '../utils/utils'
import { useMatomo } from '@datapunt/matomo-tracker-react'
import parseMax from 'libphonenumber-js/max'
import { prismicText } from '../components/Global/CMSText'
import { createClient, getSingleDocument } from '../prismicio'
import Loader from '../components/Loader/Loader'
import { LOCAL_STORAGE_KEYS } from '@/utils/constants'

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      background: theme.extraColors.greyLight,
      paddingTop: theme.spacing(10),
      paddingBottom: theme.spacing(10),
    },
    loaderContainer: {
      height: 200,
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  })
)

const mapStateToProps = (state) => ({
  user: state.user,
  addressUser: state.addressUser,
  parameters: state.parameters,
})

const mapDispatchToProps = {
  registerUser: registerUser,
  loginUser: loginUser,
  getUser: getUser,
}

type Tprops = {
  main?: any
  takeback: any
  doc?: any
  faqRes?: any
  formText?: any
  loginUser: any
  parameters: any
  getUser: () => void
  inStoreText: any
  user: any
  registerUser: any
  basket: any
  banner?: any
}

const Register = ({
  main,
  registerUser,
  loginUser,
  inStoreText,
  getUser,
  user,
  parameters,
  takeback,
  doc,
  faqRes,
  basket,
  banner,
}: Tprops) => {
  const [login, setIsLoginForm] = useState(true)
  const [register, setIsRegisterForm] = useState(false)
  const [forgot, setIsForgotForm] = useState(false)
  const [hasRegistered, setHasRegistered] = useState(false)
  const [hasError, setHasError] = useState(false)
  const [errorPhone, setHasErrorPhone] = useState(false)
  const [errorAccountDisabled, setErrorAccountDisabled] = useState(false)
  const [errorEmailUsed, setErrorEmailUsed] = useState(false)
  const [loginError, setLoginError] = useState(false)
  const classes = useStyles()
  const router = useRouter()
  const { t } = useTranslation()
  const { trackPageView, trackEvent } = useMatomo()

  const switchForm = (id) => {
    setIsRegisterForm(false)
    setIsLoginForm(false)
    setIsForgotForm(false)
    setErrorEmailUsed(false)
    setHasErrorPhone(false)
    setErrorAccountDisabled(false)
    setLoginError(false)
    setHasError(false)
    switch (id) {
      case 1:
        setIsRegisterForm(true)
        trackEvent({
          category: `Register Page`,
          action: `Show registration Form`,
        })
        break
      case 4:
        setIsLoginForm(true)
        trackEvent({
          category: `Register Page`,
          action: `Show Login Form`,
        })
        break
      case 5:
        setIsForgotForm(true)
        trackEvent({
          category: `Register Page`,
          action: `Show Forgot Password Form`,
        })
        break
      default:
        break
    }
  }
  useEffect(() => {
    trackPageView({ documentTitle: 'Register' })
    //window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [switchForm])

  // @todo: combine signup logic --- too much duplicate code
  const submitRegistration = async (data) => {
    localStorage.removeItem(LOCAL_STORAGE_KEYS.TOKEN)
    setHasErrorPhone(false)
    if (
      ['MOBILE', 'FIXED_LINE_OR_MOBILE'].includes(
        parseMax(data?.phoneNumber).getType()
      )
    ) {
      const register = await registerUser(data)
      if (register.type === 'REGISTER_USER_SUCCESS') {
        trackEvent({
          category: `Register Page`,
          action: `Customer has successfully created his account`,
        })
        if (
          typeof parameters?.items?.isAccountVerificationRequired !==
            'undefined' &&
          !parameters?.items?.isAccountVerificationRequired
        ) {
          const dataLogin = {
            email: data.email,
            password: data.plainPassword,
          }
          submitLogin(dataLogin)
        } else {
          setIsLoginForm(true)
          setHasRegistered(true)
          setHasError(false)
          setIsRegisterForm(false)
          setErrorEmailUsed(false)
        }
      } else {
        trackEvent({
          category: `Register Page`,
          action: `Customer account creation failure`,
        })
        if (
          register?.err?.response?.data?.errors?.email?.[0] ===
          'This email is already used.'
        ) {
          setErrorEmailUsed(true)
        } else {
          setHasError(true)
        }
      }
    } else {
      setHasErrorPhone(true)
    }
  }

  const submitLogin = async (data) => {
    localStorage.removeItem(LOCAL_STORAGE_KEYS.TOKEN)
    const log = await loginUser(data)
    if (log.type === 'LOGIN_USER_FAILURE') {
      if (log?.err?.response?.data?.message === 'Account is disabled.') {
        setErrorAccountDisabled(true)
      } else {
        setLoginError(true)
      }
    } else {
      if (log.token.token) {
        setLoginError(false)
        setErrorAccountDisabled(false)
        localStorage.setItem(LOCAL_STORAGE_KEYS.TOKEN, log.token.token)
        await getUser()
        trackEvent({
          category: 'Register Page',
          action: `User clicked on login button`,
        })
        router.push('/account')
      }
    }
  }

  useEffect(() => {
    if (!user?.loading && user?.isLoggedIn) {
      router.push('/account')
    }
  }, [user?.loading])

  return user.loading && !user.isLoggedIn ? (
    <div className={classes.loaderContainer}>
      <Loader />
    </div>
  ) : (
    <>
      <Layout
        mainLogo={main?.data?.logo}
        doc={main}
        t={t}
        inStoreText={inStoreText}
        data-testid="confirmation"
        metaTitle={prismicText(
          doc?.data?.meta_title_register,
          t('texts:account:herotitle')
        )}
        metaDescription={doc?.data?.meta_description_register}
        metaKeywords={doc?.data?.meta_keywords_register}
        hideTop
        takeback={takeback}
        basket={basket}
        account={doc}
        faq={faqRes}
        banner={banner}
      >
        <section className={`account ${classes.root}`}>
          {login && (
            <LoginForm
              hasRegistered={hasRegistered}
              submitLogin={submitLogin}
              loginError={loginError}
              t={t}
              errorAccountDisabled={errorAccountDisabled}
              isLoading={user.loading}
              switchForm={switchForm}
              text={doc?.data}
              isFunnel={false}
            />
          )}
          {register && (
            <RegisterForm
              submitRegistration={submitRegistration}
              switchForm={switchForm}
              t={t}
              errorPhone={errorPhone}
              hasError={hasError}
              errorEmailUsed={errorEmailUsed}
              isLoading={user.loading}
              text={doc?.data}
              generalConfigData={main?.data}
              isFunnel={false}
            />
          )}
          {forgot && (
            <ForgotPasswordForm
              isFunnel={false}
              text={doc?.data}
              t={t}
              switchForm={switchForm}
            />
          )}
        </section>
      </Layout>
    </>
  )
}

export async function getStaticProps({ locale, previewData }) {
  const client = createClient({ previewData })
  const lang = setFullLocale(locale)

  const general = await getSingleDocument(client, lang, 'general')
  const takeback = await getSingleDocument(client, lang, 'take_back')
  const account = await getSingleDocument(client, lang, 'account')
  const inStoreText = await getSingleDocument(client, lang, 'instore')
  const basket = await getSingleDocument(client, lang, 'basket')
  const faqRes = await getSingleDocument(client, lang, 'faq')
  const banner = await getSingleDocument(client, lang, 'banner')

  return {
    props: {
      main: general,
      takeback,
      inStoreText,
      doc: account,
      basket,
      faqRes,
      banner,
      i18nResources: await getTranslations(locale, ['texts']),
    },
    revalidate: 300,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Register)
